

import React from 'react';
import { SavedItem, SavedCardType } from '../types';
import { BookmarkIcon, LocationIcon } from './icons';

interface SavedItemCardProps {
    item: SavedItem;
    isBookmarked: boolean;
    onBookmarkToggle: (id: string) => void;
    onReadMore: (type: SavedCardType, id: string) => void;
}

export const SavedItemCard: React.FC<SavedItemCardProps> = ({ item, isBookmarked, onBookmarkToggle, onReadMore }) => {
    const isResearcher = item.type === SavedCardType.Researcher;

    return (
        <div className="flex w-full sm:w-[220px] sm:h-[260px] p-3 flex-col items-start rounded-xl border-[0.5px] border-primary-100 shadow-custom-light relative utech-nocopy">
            
            <div className="flex flex-col items-start gap-2 self-stretch w-full min-w-0">
                <div className="flex w-full py-1 px-2 sm:px-3 justify-center items-center rounded-[56px] bg-primary-100 min-w-0">
                    <span className="text-primary-og-600 font-grotesk text-[10px] sm:text-xs text-center whitespace-nowrap flex-shrink-0">
                        {typeof item.relevance === 'number' ? `${item.relevance}% relevance score` : item.relevance}
                    </span>
                </div>
                <div className="flex flex-col items-start gap-1 self-stretch">
                    <h4 
                        className="self-stretch text-grayscale-1300 font-grotesk text-base font-medium leading-tight"
                    >{item.title}</h4>
                    <div className="flex items-center gap-1 self-stretch">
                        <LocationIcon />
                        <span className="text-grayscale-1000 font-grotesk text-xs">{item.location}</span>
                    </div>
                </div>
            </div>

            <div className="w-full mt-auto">
                <hr className="border-t border-primary-300 my-2" />
                {isResearcher ? (
                    <div className="flex items-center gap-2 self-stretch">
                        <button onClick={() => onReadMore(item.type, item.id)} className="flex h-7 py-2 px-2 justify-center items-center gap-1 flex-1 rounded-[19px] border border-primary-200">
                            <span className="text-grayscale-1300 font-grotesk text-sm font-medium">Read More</span>
                        </button>
                        <button onClick={() => onBookmarkToggle(item.id)} className="flex p-1 justify-center items-center rounded-full bg-primary-100">
                            <BookmarkIcon filled={isBookmarked} />
                        </button>
                    </div>
                ) : (
                    <div>
                        <div className="flex justify-between items-center">
                            <span className="text-grayscale-1300 font-grotesk text-sm font-medium">{item.detail}</span>
                        </div>
                        <hr className="border-t border-primary-300 mt-1 mb-3" />
                        <div className="flex items-center gap-2 self-stretch">
                            <button onClick={() => onReadMore(item.type, item.id)} className="flex h-7 py-2 px-2 justify-center items-center gap-1 flex-1 rounded-[19px] border border-primary-200">
                                <span className="text-grayscale-1300 font-grotesk text-sm font-medium">Read More</span>
                            </button>
                            <button onClick={() => onBookmarkToggle(item.id)} className="flex p-1 justify-center items-center rounded-full bg-primary-100">
                                <BookmarkIcon filled={isBookmarked} />
                            </button>
                        </div>
                    </div>
                )}
            </div>
        </div>
    );
};